module.exports = __webpack_public_path__ + "static/texture-a98f310a656406c844e0477361e47375.png";